module.exports = __webpack_public_path__ + "static/media/10_of_clubs.0771e009.png";